import { useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { deleteUserRequest, getSeniorHomesRequest, getUsersRequest } from "../redux/actions";
import { deleteCustomerRequest, getSeniorsByHNRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import { localePath } from "../i18n/config";

const Users = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    useEffect(() => {
        if (user && (user.isAdmin || user.role === "it_support" || user.role === ROLE.HEAD_NURSE)) {
            dispatch(getUsersRequest());
            dispatch(getSeniorsByHNRequest());
            dispatch(getSeniorHomesRequest());
        } else {
            history.push(localePath("kirjaudu"));
        }
        return () => {};
    }, [dispatch, user, history]);

    const handleDelete = (id: any, role: string) => {
        if (user.role === ROLE.HEAD_NURSE && role === ROLE.CUSTOMER_SMALL) {
            dispatch(deleteCustomerRequest(id));
        } else {
            dispatch(deleteUserRequest(id));
        }
    };
    const users: any = useSelector((state: AppState) => state.users);
    const { loading, error, list } = users;

    const deleteHandler = (id: any) => {
        const user = list.users?.find((el: { id: any }) => el.id === id);
        if (window.confirm(`Haluatko varmasti poistaa asiakkaan "${user?.firstName} ${user?.lastName}" ID:${id} ?`)) {
            handleDelete(id, user?.role);
        }
    };
    const isHeadNurse = user.role === ROLE.HEAD_NURSE;
    const visibility = isHeadNurse ? "d-none" : "";

    return (
        <>
            <div className="global-row-container users-toolbar">
                <h1 className="my-3 ml-3" style={{ color: "#4e5180", fontFamily: "Poppins, sanf-serif" }}>
                    Asiakkaat
                </h1>
                <div className="float-left">
                    <LinkContainer to={`/admin/senior/add`}>
                        <Button className="add-button">Lisää seniori/asiakas</Button>
                        {/* Add a button to add a new senior user */}
                    </LinkContainer>
                    <LinkContainer to={`/admin/users/add`}>
                        <Button className="add-button">Lisää läheinen</Button>
                    </LinkContainer>
                </div>
            </div>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">{error.message}</Message>
            ) : (
                <Table striped bordered hover responsive className="users-table font-small">
                    <thead className="user-title">
                        <tr className="user">
                            <th className="text-center">{user.readOnly || !user.isAdmin ? "Muokkaa/Poista" : "Päivitä /Poista"}</th>
                            <th className="text-center">ID</th>
                            <th className="text-center">R-ID</th>
                            <th className="text-center">APP ONLY</th>
                            <th className="text-center">LOCALE</th>
                            <th className="text-center">ROOLI</th>
                            <th className="text-center">ETUNIMI</th>
                            <th className="text-center">SUKUNIMI</th>
                            <th className="text-center">KÄYTTÄJÄNIMI</th>
                            <th className="text-center">Tabletti</th>
                            <th className="text-center">PUHELIN</th>
                            <th className={`text-center ${user.role === ROLE.HEAD_NURSE ? "d-none" : ""}`}>Company</th>

                            <th className="text-center">Asumispalvelu</th>
                            <th className="text-center">Paikkakunta</th>
                            <th className="text-center">Koti/Asumispalvelu</th>
                            <th className="text-center">KOTIOSOITE</th>
                            <th className="text-center">POSTINUMERO</th>
                            <th className="text-center">KAUPUNKI</th>
                            <th className={`text-center ${user.role === ROLE.HEAD_NURSE ? "d-none" : ""}`}>ADMIN</th>
                            <th className={`text-center ${visibility}`}>ITSE SENIORI</th>
                            <th className="text-center">Updated at</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.users
                            ?.sort((a: any, b: any) => a?.id - b?.id)
                            .map((item: any) => (
                                <tr key={item.id} className="text-nowrap">
                                    <td>
                                        <LinkContainer to={`/admin/users/${item.id}`}>
                                            <Button className="btn-sm">
                                                <i
                                                    className={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE) ? "fas fa-eye" : "fas fa-edit"}
                                                    style={{
                                                        color: "#fff",
                                                    }}
                                                />
                                            </Button>
                                        </LinkContainer>
                                        {!user.readOnly && (user.isAdmin || user.role === ROLE.HEAD_NURSE) && (
                                            <Button variant="danger" className="btn-sm" onClick={() => deleteHandler(item.id)}>
                                                <i className="fas fa-trash" />
                                            </Button>
                                        )}
                                    </td>
                                    <td>{item.id}</td>
                                    <td>{item.group?.id}</td>
                                    <td>{item.appOnly ? "Yes" : "No"}</td>
                                    <td>{item.preferred_locale || "-"}</td>
                                    <td>{isHeadNurse && item.role === ROLE.CUSTOMER_SMALL ? ROLE.RELATIVE : item.role}</td>
                                    <td>{item.firstName}</td>
                                    <td>{item.lastName}</td>
                                    <td>{item.username}</td>
                                    <td>{item.device_imei4}</td>
                                    <td>{item.mobileNumber}</td>
                                    <td className={`${user.role === ROLE.HEAD_NURSE ? "d-none" : ""}`}>{item?.seniorHomes?.name}</td>

                                    <td>{item.nursingHome}</td>
                                    <td>{item.nursingHomeAddress}</td>
                                    <td>{item.department}</td>
                                    <td>{item.homeAddress}</td>
                                    <td>{item.homePostalCode}</td>
                                    <td>{item.homeCity}</td>
                                    <td style={{ textAlign: "center", display: user.role === ROLE.HEAD_NURSE ? "none" : "" }}>
                                        {item.isAdmin ? (
                                            <b style={{ color: "green" }}>
                                                ADMIN
                                                <span>{item.readOnly && "(read only)"}</span>
                                            </b>
                                        ) : (
                                            <div>USER</div>
                                        )}
                                    </td>
                                    <td className={` ${visibility}`} style={{ textAlign: "center" }}>
                                        {item.isSenior ? <b style={{ color: "green" }}>Seniori</b> : <div>Muu</div>}
                                    </td>
                                    <td>{item.updatedAt}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            )}
        </>
    );
};

export default Users;
